import { useLogout } from '@/hooks/useLogout'
import styles from './LogoutButton.module.css'

function LogoutIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.75"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  )
}

export default function LogoutButton() {
  const logout = useLogout()

  return (
    <button
      type="button"
      className={styles.logoutBtn}
      onClick={logout}
      aria-label="Log out"
      title="Log out"
    >
      <LogoutIcon />
    </button>
  )
}
